__turbopack_context__.v({
  "inner": "catalog-brands-grid-loader-module-scss-module__foqYJW__inner",
  "item": "catalog-brands-grid-loader-module-scss-module__foqYJW__item",
});
